import React, { useState, useEffect } from 'react';
import { 
  BookOpen, 
  ChevronRight, 
  ChevronLeft,
  Star, 
  Play,
  Search,
  Award,
  Clock,
  Users,
  ArrowRight,
  ChevronDown
} from 'lucide-react';

const ImprovedSportsAcademy = () => {
  const [activeSlide, setActiveSlide] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState("Todos");

  // Hero Carousel Data
  const carouselData = [
    {
      image: "/api/placeholder/1920/600",
      title: "Domina los Pronósticos Deportivos",
      subtitle:
        "Aprende de expertos y conviértete en un profesional del análisis deportivo",
      ctaText: "Explorar Cursos",
    },
    {
      image: "/api/placeholder/1920/600",
      title: "Nuevo Curso: Análisis Estadístico Avanzado",
      subtitle:
        "Descubre los secretos detrás de los pronósticos más precisos del mercado",
      ctaText: "Ver Detalles",
    },
    {
      image: "/api/placeholder/1920/600",
      title: "Comunidad Premium",
      subtitle:
        "Únete a miles de analistas y comparte conocimientos en tiempo real",
      ctaText: "Unirse Ahora",
    },
  ];

  // Categories
  const categories = [
    "Todos",
    "Fútbol",
    "Baloncesto",
    "Tenis",
    "Análisis Estadístico",
    "Gestión de Bankroll",
    "Trading Deportivo",
    "Principiantes",
  ];

  // Course Data
  const allCourses = [
    {
      id: 1,
      title: "Fundamentos de Pronósticos Deportivos",
      image: "/api/placeholder/400/225",
      instructor: "Carlos Martínez",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.8,
      reviews: 423,
      students: 2564,
      price: 59.99,
      originalPrice: 89.99,
      tags: ["Principiantes", "Fútbol"],
      level: "Básico",
      duration: "20 horas",
    },
    {
      id: 2,
      title: "Análisis Estadístico para Pronósticos",
      image: "/api/placeholder/400/225",
      instructor: "Laura Gómez",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.9,
      reviews: 512,
      students: 3120,
      price: 79.99,
      originalPrice: 129.99,
      tags: ["Análisis Estadístico", "Intermedio"],
      level: "Intermedio",
      duration: "35 horas",
    },
    {
      id: 3,
      title: "Trading de Partidos en Vivo",
      image: "/api/placeholder/400/225",
      instructor: "Miguel Rojas",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.7,
      reviews: 328,
      students: 1892,
      price: 69.99,
      originalPrice: 99.99,
      tags: ["Trading Deportivo", "Avanzado"],
      level: "Avanzado",
      duration: "28 horas",
    },
    {
      id: 4,
      title: "Pronósticos de Tenis Profesional",
      image: "/api/placeholder/400/225",
      instructor: "Ana Vidal",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.8,
      reviews: 215,
      students: 1456,
      price: 64.99,
      originalPrice: 94.99,
      tags: ["Tenis", "Intermedio"],
      level: "Intermedio",
      duration: "22 horas",
    },
    {
      id: 5,
      title: "Estrategias Avanzadas de Baloncesto",
      image: "/api/placeholder/400/225",
      instructor: "Roberto Pérez",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.9,
      reviews: 189,
      students: 1267,
      price: 74.99,
      originalPrice: 109.99,
      tags: ["Baloncesto", "Avanzado"],
      level: "Avanzado",
      duration: "32 horas",
    },
    {
      id: 6,
      title: "Gestión de Bankroll para Principiantes",
      image: "/api/placeholder/400/225",
      instructor: "Carolina Sánchez",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.8,
      reviews: 356,
      students: 2120,
      price: 49.99,
      originalPrice: 79.99,
      tags: ["Gestión de Bankroll", "Principiantes"],
      level: "Básico",
      duration: "15 horas",
    },
    {
      id: 7,
      title: "Fútbol: Análisis de Ligas Europeas",
      image: "/api/placeholder/400/225",
      instructor: "David López",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.7,
      reviews: 278,
      students: 1982,
      price: 69.99,
      originalPrice: 99.99,
      tags: ["Fútbol", "Intermedio"],
      level: "Intermedio",
      duration: "30 horas",
    },
    {
      id: 8,
      title: "Técnicas Avanzadas de Análisis Estadístico",
      image: "/api/placeholder/400/225",
      instructor: "Elena Martín",
      instructorImage: "/api/placeholder/50/50",
      rating: 4.9,
      reviews: 412,
      students: 2345,
      price: 89.99,
      originalPrice: 139.99,
      tags: ["Análisis Estadístico", "Avanzado"],
      level: "Avanzado",
      duration: "40 horas",
    },
  ];

  // Filter courses based on selected category
  const filteredCourses =
    selectedCategory === "Todos"
      ? allCourses
      : allCourses.filter((course) => course.tags.includes(selectedCategory));

  // Featured Instructors
  const instructors = [
    {
      name: "Carlos Martínez",
      image: "/api/placeholder/150/150",
      specialty: "Pronósticos de Fútbol",
      students: 12500,
      courses: 8,
      rating: 4.8,
    },
    {
      name: "Laura Gómez",
      image: "/api/placeholder/150/150",
      specialty: "Análisis Estadístico",
      students: 15200,
      courses: 12,
      rating: 4.9,
    },
    {
      name: "Miguel Rojas",
      image: "/api/placeholder/150/150",
      specialty: "Trading Deportivo",
      students: 9800,
      courses: 6,
      rating: 4.7,
    },
  ];

  // Carousel auto-scroll
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide((prevSlide) =>
        prevSlide === carouselData.length - 1 ? 0 : prevSlide + 1
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselData.length]);

  // Scroll handlers for horizontal course lists
  const scrollLeft = (elementId) => {
    document
      .getElementById(elementId)
      .scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = (elementId) => {
    document
      .getElementById(elementId)
      .scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header/Navigation - Fixed */}
      <header className="bg-white shadow-md py-4 sticky top-0 z-50">
        <div className="container mx-auto px-4 flex justify-between items-center">
          <div className="flex items-center space-x-16">
            <h1 className="text-2xl font-bold text-blue-600">
              SportsCast Academy
            </h1>
            <nav className="hidden md:flex space-x-8">
              <a
                href="#"
                className="font-medium text-gray-700 hover:text-blue-600 transition"
              >
                Inicio
              </a>
              <a
                href="#"
                className="font-medium text-gray-700 hover:text-blue-600 transition"
              >
                Cursos
              </a>
              <a
                href="#"
                className="font-medium text-gray-700 hover:text-blue-600 transition"
              >
                Instructores
              </a>
              <a
                href="#"
                className="font-medium text-gray-700 hover:text-blue-600 transition"
              >
                Blog
              </a>
            </nav>
          </div>
          <div className="flex items-center space-x-4">
            <div className="relative hidden md:block">
              <input
                type="text"
                placeholder="Buscar cursos..."
                className="py-2 px-4 pl-10 border border-gray-300 rounded-full bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent w-64"
              />
              <Search
                className="absolute left-3 top-2.5 text-gray-400"
                size={18}
              />
            </div>
            <button className="bg-blue-600 text-white px-5 py-2 rounded-full hover:bg-blue-700 transition">
              Iniciar Sesión
            </button>
          </div>
        </div>
      </header>

      {/* Hero Carousel */}
      <section className="relative">
        <div className="overflow-hidden h-96 md:h-96 lg:h-108">
          {carouselData.map((slide, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${
                index === activeSlide ? "opacity-100" : "opacity-0"
              }`}
            >
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${slide.image})` }}
              >
                <div className="absolute inset-0 bg-black bg-opacity-50"></div>
              </div>
              <div className="relative h-full flex items-center">
                <div className="container mx-auto px-6 md:px-12">
                  <div className="max-w-lg">
                    <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
                      {slide.title}
                    </h2>
                    <p className="text-xl text-white mb-8">{slide.subtitle}</p>
                    <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-medium transition flex items-center">
                      {slide.ctaText}
                      <ChevronRight size={20} className="ml-2" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Carousel Controls */}
        <button
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-30 hover:bg-opacity-50 rounded-full p-2 text-white transition"
          onClick={() =>
            setActiveSlide((prev) =>
              prev === 0 ? carouselData.length - 1 : prev - 1
            )
          }
        >
          <ChevronLeft size={24} />
        </button>
        <button
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-30 hover:bg-opacity-50 rounded-full p-2 text-white transition"
          onClick={() =>
            setActiveSlide((prev) =>
              prev === carouselData.length - 1 ? 0 : prev + 1
            )
          }
        >
          <ChevronRight size={24} />
        </button>

        {/* Carousel Indicators */}
        <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 flex space-x-2">
          {carouselData.map((_, index) => (
            <button
              key={index}
              className={`w-3 h-3 rounded-full transition ${
                index === activeSlide ? "bg-blue-600" : "bg-white bg-opacity-50"
              }`}
              onClick={() => setActiveSlide(index)}
            ></button>
          ))}
        </div>
      </section>

      {/* Stats Banner */}
      <section className="bg-white py-6 border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center">
            <div>
              <p className="text-3xl font-bold text-blue-600">100+</p>
              <p className="text-gray-600">Cursos</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-blue-600">50k+</p>
              <p className="text-gray-600">Estudiantes</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-blue-600">25+</p>
              <p className="text-gray-600">Expertos</p>
            </div>
            <div>
              <p className="text-3xl font-bold text-blue-600">4.8</p>
              <p className="text-gray-600">Valoración Media</p>
            </div>
          </div>
        </div>
      </section>

      {/* Course Categories with Horizontal Scroll */}
      <section className="py-12">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800">
                Explora Nuestros Cursos
              </h2>
              <p className="text-gray-600 mt-2">
                Descubre contenido de alta calidad creado por expertos en la
                industria
              </p>
            </div>
            <a
              href="#"
              className="text-blue-600 font-medium flex items-center hover:text-blue-700 transition"
            >
              Ver todos
              <ArrowRight size={16} className="ml-1" />
            </a>
          </div>

          {/* Category Filter */}
          <div className="flex overflow-x-auto hide-scrollbar pb-4 mb-6 -mx-2">
            {categories.map((category) => (
              <button
                key={category}
                className={`px-6 py-2 mx-2 rounded-full whitespace-nowrap transition ${
                  selectedCategory === category
                    ? "bg-blue-600 text-white"
                    : "bg-gray-100 text-gray-800 hover:bg-gray-200"
                }`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Course Cards with Horizontal Scroll */}
          <div className="relative">
            <div
              id="coursesContainer"
              className="flex space-x-6 overflow-x-auto hide-scrollbar py-4 pb-8"
            >
              {filteredCourses.map((course) => (
                <div
                  key={course.id}
                  className="flex-shrink-0 w-72 bg-white rounded-xl shadow-md overflow-hidden border border-gray-100 hover:shadow-xl transition duration-300"
                >
                  <div className="relative">
                    <img
                      src={course.image}
                      alt={course.title}
                      className="w-full h-40 object-cover"
                    />
                    <div className="absolute top-3 right-3 bg-blue-600 text-white px-2 py-1 text-xs font-medium rounded">
                      {course.level}
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="font-bold text-lg mb-2 line-clamp-2 h-14">
                      {course.title}
                    </h3>
                    <div className="flex items-center mb-3">
                      <img
                        src={course.instructorImage}
                        alt={course.instructor}
                        className="w-8 h-8 rounded-full mr-2"
                      />
                      <p className="text-sm text-gray-600">
                        {course.instructor}
                      </p>
                    </div>
                    <div className="flex items-center mb-3">
                      <div className="flex text-yellow-400 mr-1">
                        {[...Array(5)].map((_, i) => (
                          <Star
                            key={i}
                            size={14}
                            fill={
                              i < Math.floor(course.rating)
                                ? "currentColor"
                                : "none"
                            }
                            className={
                              i < Math.floor(course.rating)
                                ? ""
                                : "text-gray-300"
                            }
                          />
                        ))}
                      </div>
                      <span className="text-sm font-medium">
                        {course.rating}
                      </span>
                      <span className="text-xs text-gray-500 ml-1">
                        ({course.reviews})
                      </span>
                      <div className="ml-auto flex items-center text-xs text-gray-500">
                        <Clock size={12} className="mr-1" />
                        {course.duration}
                      </div>
                    </div>
                    <div className="flex items-center justify-between pt-3 border-t border-gray-100">
                      <div>
                        <span className="font-bold text-lg text-blue-600">
                          ${course.price}
                        </span>
                        <span className="text-sm text-gray-500 line-through ml-2">
                          ${course.originalPrice}
                        </span>
                      </div>
                      <button className="bg-blue-100 text-blue-600 p-2 rounded-full hover:bg-blue-200 transition">
                        <Play size={18} fill="currentColor" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <button
              className="absolute left-0 top-1/2 transform -translate-y-1/2 bg-white shadow-md rounded-full p-2 text-gray-600 hover:text-blue-600 transition"
              onClick={() => scrollLeft("coursesContainer")}
            >
              <ChevronLeft size={24} />
            </button>
            <button
              className="absolute right-0 top-1/2 transform -translate-y-1/2 bg-white shadow-md rounded-full p-2 text-gray-600 hover:text-blue-600 transition"
              onClick={() => scrollRight("coursesContainer")}
            >
              <ChevronRight size={24} />
            </button>
          </div>
        </div>
      </section>

      {/* Featured Categories */}
      <section className="py-12 bg-gray-100">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-3">
              Aprende por Categoría
            </h2>
            <p className="text-gray-600 max-w-xl mx-auto">
              Especialízate en el área que más te interese con nuestros cursos
              organizados por categorías
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition">
              <div className="h-40 bg-blue-600 flex items-center justify-center">
                <BookOpen size={64} className="text-white" />
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl mb-2">
                  Pronósticos de Fútbol
                </h3>
                <p className="text-gray-600 mb-4">
                  Análisis de partidos, ligas y competiciones de fútbol a nivel
                  mundial.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-blue-600 font-medium">24 cursos</span>
                  <a
                    href="#"
                    className="text-gray-600 hover:text-blue-600 transition group-hover:translate-x-1 transform duration-300 flex items-center"
                  >
                    Ver cursos
                    <ChevronRight size={16} className="ml-1" />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition">
              <div className="h-40 bg-green-600 flex items-center justify-center">
                <Award size={64} className="text-white" />
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl mb-2">Análisis Estadístico</h3>
                <p className="text-gray-600 mb-4">
                  Metodologías y técnicas para el análisis de datos deportivos
                  avanzados.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-blue-600 font-medium">18 cursos</span>
                  <a
                    href="#"
                    className="text-gray-600 hover:text-blue-600 transition group-hover:translate-x-1 transform duration-300 flex items-center"
                  >
                    Ver cursos
                    <ChevronRight size={16} className="ml-1" />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition">
              <div className="h-40 bg-purple-600 flex items-center justify-center">
                <Users size={64} className="text-white" />
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl mb-2">Trading Deportivo</h3>
                <p className="text-gray-600 mb-4">
                  Técnicas y estrategias para el trading en mercados deportivos.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-blue-600 font-medium">12 cursos</span>
                  <a
                    href="#"
                    className="text-gray-600 hover:text-blue-600 transition group-hover:translate-x-1 transform duration-300 flex items-center"
                  >
                    Ver cursos
                    <ChevronRight size={16} className="ml-1" />
                  </a>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl shadow-md overflow-hidden group hover:shadow-lg transition">
              <div className="h-40 bg-red-600 flex items-center justify-center">
                <Search size={64} className="text-white" />
              </div>
              <div className="p-6">
                <h3 className="font-bold text-xl mb-2">Gestión de Bankroll</h3>
                <p className="text-gray-600 mb-4">
                  Métodos para optimizar la administración del capital en
                  apuestas.
                </p>
                <div className="flex justify-between items-center">
                  <span className="text-blue-600 font-medium">9 cursos</span>
                  <a
                    href="#"
                    className="text-gray-600 hover:text-blue-600 transition group-hover:translate-x-1 transform duration-300 flex items-center"
                  >
                    Ver cursos
                    <ChevronRight size={16} className="ml-1" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Instructors */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-4">
          <div className="flex justify-between items-center mb-8">
            <div>
              <h2 className="text-3xl font-bold text-gray-800">
                Nuestros Instructores
              </h2>
              <p className="text-gray-600 mt-2">
                Expertos en pronósticos deportivos con años de experiencia en la
                industria
              </p>
            </div>
            <a
              href="#"
              className="text-blue-600 font-medium flex items-center hover:text-blue-700 transition"
            >
              Ver todos
              <ArrowRight size={16} className="ml-1" />
            </a>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {instructors.map((instructor, index) => (
              <div
                key={index}
                className="bg-gray-50 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition"
              >
                <div className="flex flex-col items-center pt-8 pb-6">
                  <img
                    src={instructor.image}
                    alt={instructor.name}
                    className="w-32 h-32 rounded-full mb-4 object-cover border-4 border-white shadow-md"
                  />
                  <h3 className="font-bold text-xl">{instructor.name}</h3>
                  <p className="text-blue-600 mb-2">{instructor.specialty}</p>
                  <div className="flex text-yellow-400 mb-4">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        size={16}
                        fill={
                          i < Math.floor(instructor.rating)
                            ? "currentColor"
                            : "none"
                        }
                        className={
                          i < Math.floor(instructor.rating)
                            ? ""
                            : "text-gray-300"
                        }
                      />
                    ))}
                    <span className="text-gray-600 ml-2">
                      {instructor.rating}
                    </span>
                  </div>
                  <div className="flex w-full justify-center space-x-6 text-gray-600">
                    <div className="text-center">
                      <p className="font-bold text-lg">
                        {instructor.students.toLocaleString()}
                      </p>
                      <p className="text-sm">Estudiantes</p>
                    </div>
                    <div className="text-center">
                      <p className="font-bold text-lg">{instructor.courses}</p>
                      <p className="text-sm">Cursos</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white p-4 text-center">
                  <button className="text-blue-600 font-medium hover:text-blue-700 transition">
                    Ver perfil
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-blue-600 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4">
              Lo que dicen nuestros estudiantes
            </h2>
            <p className="max-w-2xl mx-auto text-blue-100">
              Historias de éxito de personas que mejoraron sus habilidades con
              nuestros cursos
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            <div className="bg-white rounded-xl p-6 text-gray-800">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="italic mb-6">
                "Los cursos de análisis estadístico transformaron mi enfoque
                hacia los pronósticos. Aumenté mi efectividad en un 35% en solo
                3 meses."
              </p>
              <div className="flex items-center">
                <img
                  src="/api/placeholder/50/50"
                  alt="Testimonio"
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div>
                  <p className="font-bold">Alejandro Ruiz</p>
                  <p className="text-sm text-gray-500">Estudiante desde 2023</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 text-gray-800">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="italic mb-6">
                "La metodología es excelente y el contenido está actualizado
                constantemente. La comunidad de estudiantes es muy activa y
                colaborativa."
              </p>
              <div className="flex items-center">
                <img
                  src="/api/placeholder/50/50"
                  alt="Testimonio"
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div>
                  <p className="font-bold">María González</p>
                  <p className="text-sm text-gray-500">Estudiante desde 2022</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 text-gray-800">
              <div className="flex text-yellow-400 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={16} fill="currentColor" />
                ))}
              </div>
              <p className="italic mb-6">
                "Lo que más valoro es el acceso directo a expertos de la
                industria. Sus consejos prácticos son oro puro para cualquier
                analista deportivo."
              </p>
              <div className="flex items-center">
                <img
                  src="/api/placeholder/50/50"
                  alt="Testimonio"
                  className="w-12 h-12 rounded-full mr-4"
                />
                <div>
                  <p className="font-bold">Carlos Vega</p>
                  <p className="text-sm text-gray-500">Estudiante desde 2023</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-3">
              Preguntas Frecuentes
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto">
              Respuestas a las dudas más comunes sobre nuestros cursos y
              metodología
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            {[
              {
                question: "¿Cómo funcionan los cursos online?",
                answer:
                  "Nuestros cursos están disponibles 24/7 en nuestra plataforma. Una vez matriculado, tendrás acceso ilimitado al contenido, que incluye vídeos, lecturas, ejercicios prácticos y acceso a nuestra comunidad. Puedes avanzar a tu ritmo y acceder desde cualquier dispositivo.",
              },
              {
                question: "¿Cuánto tiempo tengo acceso al curso?",
                answer:
                  "Una vez que te matriculas en un curso, tienes acceso de por vida. Esto incluye también todas las actualizaciones futuras que se realicen en el contenido del curso.",
              },
              {
                question: "¿Los cursos incluyen certificación?",
                answer:
                  "Sí, todos nuestros cursos incluyen un certificado de finalización que podrás descargar una vez hayas completado todas las lecciones y evaluaciones. Nuestros certificados están reconocidos en la industria de análisis deportivo.",
              },
              {
                question: "¿Ofrecen alguna garantía de devolución?",
                answer:
                  "Sí, ofrecemos una garantía de devolución de 30 días. Si no estás satisfecho con el curso, puedes solicitar un reembolso completo dentro de los primeros 30 días desde la fecha de compra.",
              },
              {
                question: "¿Necesito conocimientos previos para los cursos?",
                answer:
                  "Depende del nivel del curso. Tenemos cursos para principiantes que no requieren conocimientos previos, así como cursos avanzados que pueden requerir cierta experiencia en análisis deportivo. En la descripción de cada curso se especifica el nivel recomendado.",
              },
            ].map((faq, index) => (
              <div
                key={index}
                className="mb-6 bg-white rounded-xl shadow-sm p-6"
              >
                <div className="flex justify-between items-center cursor-pointer">
                  <h3 className="text-lg font-bold text-gray-800">
                    {faq.question}
                  </h3>
                  <ChevronDown size={20} className="text-blue-600" />
                </div>
                <div className="mt-3 text-gray-600">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-8">
            <a
              href="#"
              className="text-blue-600 font-medium hover:text-blue-700 transition"
            >
              Ver todas las preguntas frecuentes
            </a>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">
              Comienza tu camino como analista profesional
            </h2>
            <p className="text-xl mb-8 text-blue-100">
              Únete a miles de estudiantes que ya están mejorando sus
              habilidades de pronósticos deportivos
            </p>
            <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4">
              <button className="bg-white text-blue-600 px-8 py-3 rounded-full font-medium hover:bg-gray-100 transition">
                Explorar cursos
              </button>
              <button className="bg-transparent border-2 border-white text-white px-8 py-3 rounded-full font-medium hover:bg-white hover:bg-opacity-10 transition">
                Prueba gratuita
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-gray-400 pt-16 pb-8">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div>
              <h3 className="text-2xl font-bold text-white mb-4">
                SportsCast Academy
              </h3>
              <p className="mb-4">
                La plataforma líder en formación para analistas y
                pronosticadores deportivos profesionales.
              </p>
              <div className="flex space-x-4">
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
                <a
                  href="#"
                  className="text-gray-400 hover:text-white transition"
                >
                  <svg
                    className="w-6 h-6"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      fillRule="evenodd"
                      d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z"
                      clipRule="evenodd"
                    />
                  </svg>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Enlaces Rápidos</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="hover:text-white transition">
                    Inicio
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Cursos
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Instructores
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Blog
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Contacto
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Categorías</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="hover:text-white transition">
                    Fútbol
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Baloncesto
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Tenis
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Análisis Estadístico
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Trading Deportivo
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-white font-bold mb-4">Soporte</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="hover:text-white transition">
                    Preguntas Frecuentes
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Política de Privacidad
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Términos y Condiciones
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Soporte Técnico
                  </a>
                </li>
                <li>
                  <a href="#" className="hover:text-white transition">
                    Centro de Ayuda
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-800 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p>
                &copy; 2025 SportsCast Academy. Todos los derechos reservados.
              </p>
              <div className="mt-4 md:mt-0">
                <a
                  href="#"
                  className="text-sm mr-4 hover:text-white transition"
                >
                  Privacidad
                </a>
                <a
                  href="#"
                  className="text-sm mr-4 hover:text-white transition"
                >
                  Términos
                </a>
                <a href="#" className="text-sm hover:text-white transition">
                  Cookies
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ImprovedSportsAcademy;